import React, { useState, useEffect } from 'react'
import { NavLink, useHistory } from 'react-router-dom'
import { useStore } from '../lib'
import { CertificateSummer } from './CertificateSummer'
import { CertificateWinter } from './CertificateWinter'

export const Certificate = () => {
  const [width, setWidth] = useState<number>(0)
  const [username, setUsername] = useState<string>('')
  const [successRate, setSuccessRate] = useState<number>(0)
  const { state, patchState } = useStore()
  const history = useHistory()

  useEffect(() => {
    let w = window.innerWidth
    if (window.innerHeight < (w / 1920) * 1200) {
      const p = window.innerHeight / (((w / 1920) * 1200) / 100)
      w = w * (p / 100) - 30
    }
    setWidth(w * 0.8)
    // setTimeout(() => window.print(), 300)
  }, [])

  useEffect(() => {
    setUsername(state.username)
    let [nextScore, nextErrors, nextSuccessRate] = [0, 0, 0]
    Object.keys(state.games).forEach((g: any) => {
      nextScore += state.games[g].score
      nextErrors += state.games[g].errors
    })
    nextSuccessRate = 100 - nextErrors / ((nextScore + nextErrors) / 100)
    setSuccessRate(isNaN(nextSuccessRate) ? 0 : nextSuccessRate)
  }, [state])

  return (
    <div className="view">
      <div className="p-5 text-black view-content">
        <div style={{ width }}>
          {state.isWinter ? (
            <CertificateWinter username={username} successRate={successRate} />
          ) : (
            <CertificateSummer username={username} successRate={successRate} />
          )}
        </div>
        {/*<div className="fixed z-10 bottom-0 left-5 noprint">*/}
        {/*  <button className="text-xl text-black btn btn-block mb-5 glass" onClick={() => history.goBack()}>*/}
        {/*    zpět*/}
        {/*  </button>*/}
        {/*</div>*/}
      </div>
    </div>
  )
}
